import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/search-results/:searchString',
      name: 'search-results',
      component: () =>
        import(/* webpackChunkName: "search-results" */ './views/SearchResults.vue')
    },
    {
      path: '/all-honorees',
      name: 'all-honorees',
      component: () =>
        import(/* webpackChunkName: "all-honorees" */ './views/AllHonorees.vue')
    },
    {
      path: '/honoree-list/:honor',
      name: 'honoree-list',
      component: () =>
        import(/* webpackChunkName: "honoree-list" */ './views/HonoreeList.vue')
    },
    {
      path: '/honoree-list/:honor/:id',
      name: 'honoree-detail',
      component: () =>
        import(/* webpackChunkName: "honoree-detail" */ './views/HonoreeDetail.vue')
    },
    {
      path: '/certificate-list',
      name: 'certificate-list',
      component: () =>
        import(/* webpackChunkName: "certificate-list" */ './views/CertificateList.vue')
    },
    {
      path: '/certificate-list/:sport',
      name: 'certificate-detail',
      component: () =>
        import(/* webpackChunkName: "certificate-detail" */ './views/CertificateDetail.vue')
    }
  ]
});
